module.exports = __webpack_public_path__ + "static/media/chart-network.e715e37c.svg";